import React from 'react';
import Dashboard from './Dashboard';

const App = () => {
  return (
    <div className="app-root">
      <Dashboard />
    </div>
  );
};

export default App;
